import fadeTabs from './tabs.js';
import { flipOut, flipIn } from '../utility';

const tabsContainer = document.querySelector('[data-quote-carousel]');

export default class quoteCarousel {
  constructor() {
    () => {};
    this.init();
  }

  init() {
    new fadeTabs(tabsContainer, {
      childSelector: '[data-quote-carousel-tab-id]',
      activeClass: 'quote-carousel__tab--active',
      onSelect: (activeTab, inactiveTabs) => {
        inactiveTabs.forEach(tab => {
          flipOut(tabsContainer.querySelector(`[data-quote-carousel-content="${tab.getAttribute('data-quote-carousel-tab-id')}"]`), {
            done() {
              flipIn(tabsContainer.querySelector(`[data-quote-carousel-content="${activeTab.getAttribute('data-quote-carousel-tab-id')}"]`));
            },
          });
        });
      },
    });
  }
}
